import React from "react";
import BaseButton from "./BaseButton";
import {
  MdOutlineMeetingRoom,
  MdOutlinePeopleOutline,
  MdOutlineCoPresent,
  MdOutlineAccountBalance,
  MdOutlineClass,
} from "react-icons/md";
import { useTranslation } from "react-i18next";

const quickAccessItems = [
  {
    id: "M-4-facility-007",
    label_ja: "事務局",
    label_en: "Office",
    icon: MdOutlineMeetingRoom,
  },
  {
    id: "M-3-facility-006",
    label_ja: "社会連携センター",
    label_en: "Society Collaboration Center",
    icon: MdOutlinePeopleOutline,
  },
  {
    id: "M-3-classroom-001",
    label_ja: "大講義室",
    label_en: "Big Lecture",
    icon: MdOutlineCoPresent,
  },
  {
    id: "M-4-classroom-001",
    label_ja: "講堂",
    label_en: "Lecture Hall",
    icon: MdOutlineAccountBalance,
  },
  {
    id: "R-2-classroom-791",
    label_ja: "中講義室 R791",
    label_en: "Room R791",
    icon: MdOutlineClass,
  },
];

interface QuickAccessNavProps {
  onSelect: (id: string) => void;
  isMobile?: boolean; // モバイル端末かどうか
  isRouteActive?: boolean; // 経路表示中かどうか
  onBlockedSelect?: () => void; // 経路表示中 (無効状態) にタップされたとき
}

export const QuickAccessNav: React.FC<QuickAccessNavProps> = ({
  onSelect,
  isMobile = false,
  isRouteActive = false,
  onBlockedSelect,
}) => {
  const { i18n } = useTranslation();
  if (isMobile) {
    return null;
  }
  const isEnglish = (i18n.resolvedLanguage ?? "ja").startsWith("en");
  const textVariant = "body/s";
  const buttonClassName = isEnglish
    ? "w-auto px-3 py-2 text-center whitespace-nowrap"
    : "flex-none px-3 py-2 whitespace-nowrap";

  const renderButton = (item: (typeof quickAccessItems)[number]) => (
    <BaseButton
      key={item.id}
      icon={item.icon}
      onClick={() => onSelect(item.id)}
      className={buttonClassName}
      textVariant={textVariant}
      disabled={isRouteActive}
    >
      {isEnglish ? item.label_en : item.label_ja}
    </BaseButton>
  );

  return (
    // backdrop-blur は地図上で重いため使わない
    <div className="relative hidden w-fit max-w-full rounded-4xl bg-white/85 py-4 px-6 sm:block mx-auto">
      {isEnglish ? (
        <div className="flex flex-col gap-3">
          <div className="flex flex-nowrap justify-center gap-3">
            {quickAccessItems.slice(0, 2).map(renderButton)}
          </div>
          <div className="flex flex-nowrap justify-center gap-3">
            {quickAccessItems.slice(2).map(renderButton)}
          </div>
        </div>
      ) : (
        <div className="flex flex-nowrap justify-center gap-3">
          {quickAccessItems.map(renderButton)}
        </div>
      )}
      {/* disabled のボタンはクリックを出さないので、経路表示中は透明な層で受ける */}
      {isRouteActive && onBlockedSelect && (
        <div
          aria-hidden="true"
          className="absolute inset-0 rounded-4xl"
          onClick={onBlockedSelect}
        />
      )}
    </div>
  );
};

export default QuickAccessNav;
